import React from 'react';
import IndustryPageTemplate from '../../components/IndustryPageTemplate';
import SEO from '../../components/SEO';

const JunkRemoval = () => {
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How can Local Business Heroes help my junk removal business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Local Business Heroes helps junk removal businesses capture more leads, automate follow-ups, reduce no-shows, and grow faster. Rated 4.9/5 by 1,200+ UK businesses."
        }
      },
      {
        "@type": "Question",
        "name": "How much does it cost for junk removal businesses?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Plans start at £297/month with a 14-day trial for just £5. Most junk removal businesses see ROI within the first month."
        }
      },
      {
        "@type": "Question",
        "name": "Do I need technical skills to use it?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Local Business Heroes is designed for busy business owners with zero tech experience. Setup takes 5 minutes with UK-based support."
        }
      },
      {
        "@type": "Question",
        "name": "Will it work for my junk removal business?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes. Local Business Heroes is specifically designed for local service businesses like junk removal. Features include appointment scheduling, automated reminders, lead capture, and customer management."
        }
      }
    ]
  };

  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "CRM for Junk Removal - Local Business Heroes",
    "applicationCategory": "BusinessApplication",
    "offers": {
      "@type": "Offer",
      "price": "297",
      "priceCurrency": "GBP"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "1200"
    }
  };

  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Industries", url: "/industries" },
    { name: "Junk Removal CRM", url: "/industries/junk-removal" }
  ];

  const industryData = {
    name: 'Junk Removal',
    title: 'Capture Same-Day Requests & Fill Your Truck Schedule Faster',
    subtitle: 'Never miss urgent removal calls, automate estimates, and turn one-time jobs into recurring cleanout contracts',
    icon: '🗑️',
    challenges: [
      'Missing same-day urgent requests',
      'Too much time spent giving estimates',
      'Hard to fill truck schedule efficiently',
      'One-time customers never return',
      'Difficult to manage disposal logistics'
    ],
    solutions: [
      'Instant same-day request capture',
      'Photo-based estimate automation',
      'Route optimization for truck scheduling',
      'Estate cleanout lead nurture',
      'Disposal tracking and invoicing'
    ],
    features: [
      'Emergency call capture 24/7',
      'Photo estimate system',
      'Truck scheduling optimization',
      'Commercial account management',
      'Before/after documentation',
      'Disposal tracking',
      'Review automation',
      'Referral program management'
    ],
    results: [
      'Fill 95% of truck capacity',
      'Book 3x more same-day jobs',
      '45% get recurring cleanout contracts',
      '£6.4K average monthly revenue increase'
    ]
  };

  return (
    <>
      <SEO 
        title="CRM for Junk Removal UK | Marketing Automation | Local Business Heroes"
        description="Rated 4.9/5. CRM and marketing automation for junk removal businesses. Capture more leads, automate follow-up, grow faster. Start £5 trial today."
        keywords="CRM for junk removal UK, junk removal business software, junk removal customer management, junk removal lead generation UK"
        url="/industries/junk-removal"
        schemaMarkup={[faqSchema, localBusinessSchema]}
        breadcrumbs={breadcrumbs}
      />
      <IndustryPageTemplate industry={industryData} />
    </>
  );
};

export default JunkRemoval;